// src/pages/AuthPage.jsx
import { useState } from 'react';

export default function AuthPage({ onLogin, onRegister }) {
  const [mode, setMode] = useState('login');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const errorMessages = {
    'auth/invalid-credential': 'E-mail ou senha incorretos.',
    'auth/email-already-in-use': 'Este e-mail já está cadastrado.',
    'auth/weak-password': 'A senha precisa ter pelo menos 6 caracteres.',
    'auth/invalid-email': 'E-mail inválido.',
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (mode === 'login') {
        await onLogin(email, password);
      } else {
        if (!name.trim()) { setError('Digite seu nome.'); setLoading(false); return; }
        await onRegister(name, email, password);
      }
    } catch (err) {
      setError(errorMessages[err.code] || 'Algo deu errado. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-screen">
      <div className="auth-box">
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <svg viewBox="0 0 24 24">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
          </div>
          <div className="auth-title">Minhas Finanças</div>
          <div className="auth-subtitle">
            {mode === 'login' ? 'Entre na sua conta' : 'Crie sua conta gratuita'}
          </div>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && <div className="auth-error">{error}</div>}

          {mode === 'register' && (
            <div className="field">
              <label>Seu nome</label>
              <input
                type="text"
                placeholder="ex: João Silva"
                value={name}
                onChange={e => setName(e.target.value)}
                required
              />
            </div>
          )}

          <div className="field">
            <label>E-mail</label>
            <input
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="field" style={{ marginBottom: '20px' }}>
            <label>Senha</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', height: 42, fontSize: 14, justifyContent: 'center' }}
            disabled={loading}
          >
            {loading ? 'Aguarde...' : mode === 'login' ? 'Entrar' : 'Criar conta'}
          </button>

          <div className="auth-toggle">
            {mode === 'login' ? (
              <>Não tem conta?{' '}
                <button type="button" onClick={() => { setMode('register'); setError(''); }}>
                  Cadastre-se
                </button>
              </>
            ) : (
              <>Já tem conta?{' '}
                <button type="button" onClick={() => { setMode('login'); setError(''); }}>
                  Entrar
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
